import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-email-preferences',
  templateUrl: './email-preferences.component.html',
  styleUrls: ['./email-preferences.component.css'],
})
export class EmailPreferencesComponent implements OnChanges {
  @Output() UpdateUserEmailPreferences = new EventEmitter<any>();
  @Input() getUserEmailPreferences: any;
  isChecked: any;

  constructor(private ref: ChangeDetectorRef, private cookieService: CookieService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    this.isChecked = this.getUserEmailPreferences.value;
  }

  useEmailPreferences(event: any) {
    const data = {
      isnotify: this.isChecked,
      userId: this.cookieService.get('userId'),
    };
    this.UpdateUserEmailPreferences.emit(data);
  }
}
